import { DisplayColumnDef, flexRender } from '@tanstack/react-table'
import { useAtomValue } from 'jotai'
import { useContext } from 'react'

import { TQrData } from '@/generator/shared'

import { rowContext, tableAtom } from '../tableState'
import { TRow, TTable } from '../tableTypes'

export const renderDisplayCell = <T>(
	row: TRow,
	table: TTable,
	colDef: DisplayColumnDef<TQrData, T>,
) => {
	const column = table.getColumn(colDef.id!)
	if (!column) return null

	const cell = row
		.getVisibleCells()
		.find((cell) => cell.column.id === colDef.id)
	if (!cell) return null

	return flexRender(column.columnDef.cell, cell.getContext())
}

export const useRenderDisplayCell = <T>(
	colDef: DisplayColumnDef<TQrData, T>,
) => {
	const row = useContext(rowContext)
	const table = useAtomValue(tableAtom)

	return renderDisplayCell(row, table, colDef)
}
